import { createFeatureSelector, createSelector } from '@ngrx/store';

import * as fromStaticDataReducer from '../reducers';
import * as staticDataCountriesReducer from '../reducers/index';
import * as staticDataReducer from '../static-data.reducer';

//#region Static Data ROOT STATE
export const getAuthState = createFeatureSelector<staticDataReducer.State, staticDataReducer.StaticDataState>(
  staticDataReducer.staticDataFeatureKey
);
//#endregion

export const getStaticDataUserRolesState = createSelector(
  getAuthState,
  state => state[fromStaticDataReducer.fromStaticDataUserRolesReducer.userRolesFeatureKey]
);

export const getStaticDataUserRolesFailure = createSelector(
  getStaticDataUserRolesState,
  staticDataCountriesReducer.fromStaticDataUserRolesReducer.getUserRolesFailure
);

export const getStaticDataUserRolesResponse = createSelector(
  getStaticDataUserRolesState,
  staticDataCountriesReducer.fromStaticDataUserRolesReducer.getUserRolesResponse
);

export const getStaticDataUserRolesisLoaded = createSelector(
  getStaticDataUserRolesState,
  staticDataCountriesReducer.fromStaticDataUserRolesReducer.getUserRolesIsLoaded
);
